import { render, staticRenderFns } from "./sshx.vue?vue&type=template&id=3192aa80&scoped=true&"
import script from "./sshx.vue?vue&type=script&lang=js&"
export * from "./sshx.vue?vue&type=script&lang=js&"
import style0 from "./sshx.vue?vue&type=style&index=0&id=3192aa80&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3192aa80",
  null
  
)

export default component.exports